module.exports = __webpack_public_path__ + "static/media/card1.c012b48c.jpg";